import React, { useEffect, useState } from "react";
import { API_URL, ENDPOINTS, postData } from "../../constants/api";
import styles from "./markSheet.module.css";

const Marksheet = ({ studentId }) => {
  const [marksData, setMarksData] = useState([]);
  console.log('Student ID:', studentId);

  useEffect(() => {
    const fetchMarks = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/web-marksheet`;
        const body = { std_id: studentId };
        const response = await postData(url, body);
        console.log('Marksheet data:', response.data);

        const data = response.data.map((item, index) => ({
          No: index + 1,
          ...item,
        }));

        setMarksData(data);
      } catch (error) {
        console.error("Error fetching marksheet:", error);
      }
    };

    if (studentId) fetchMarks();
  }, [studentId]);

  // Group by semester
  const groupedBySemester = marksData.reduce((acc, item) => {
    const semester = item.Semester;
    if (!acc[semester]) acc[semester] = [];
    acc[semester].push(item);
    return acc;
  }, {});

  return (
    <div className={styles.marksheetContainer}>
      {Object.keys(groupedBySemester).length === 0 && <p>No marks available.</p>}

      {Object.keys(groupedBySemester).map((semester) => (
        <div key={semester} className={styles.semesterTable}>
          <h3 className={styles.semesterTitle}>{semester}</h3>

          {/* Table wrapper for scrollable table */}
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  {Object.keys(groupedBySemester[semester][0])
                    .filter((col) => col !== "Semester")
                    .map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {groupedBySemester[semester].map((row, idx) => (
                  <tr key={idx}>
                    {Object.keys(row)
                      .filter((col) => col !== "Semester")
                      .map((col) => (
                        <td key={col}>{row[col]}</td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Marksheet;
